export default __webpack_public_path__ + "static/media/img--balcony.fe8d1f50.jpg";